module.exports = __webpack_public_path__ + "static/media/inclined-lines.e7fd0067.png";